import { Utils } from './utils';
import { Forms } from './forms';
const formSelector = ".contact-form";
const validationRules = {
    firstName: {
        required: true,
    },
    lastName: {
        required: true,
    },
    email: {
        required: true,
        email: true,
    },
    phone: {
        required: true,
        phone: true
    },
    message: {
        required: true,
    },
    privacyPolicyAccepted: {
        required: true,
    }
};
const validationMessages = {
    firstName: {
        required: "Please provide your first name",
    },
    lastName: {
        required: "Please provide your last name",
    },
    email: {
        required: "Please enter your email",
        email: "Please enter a valid email address"
    },
    phone: {
        required: "Please provide a phone number for contact purposes",
        phone: "Please enter a valid phone number"
    },
    message: {
        required: "Please provide a message to send",
    },
    privacyPolicyAccepted: {
        required: "Please accept our privacy policy"
    }
};
/**
 * Initializes form validation and submission for the Contact Us form, with the GAEvent object configured for tracking.
 * @param formSelector The CSS selector for the form to be validated.
 * @param validationRules The validation rules to be applied to the form fields.
 * @param validationMessages The validation messages to be displayed for each field.
 */
function initializeFormValidation(formSelector, validationRules, validationMessages = undefined) {
    const { landingPage, conversionPagePath, gtmCode, spotCode, campaignName, campaignTerm, campaignMedium } = Utils.GetTrackingDataFromHiddenFields();
    let contactFormGAEvent = {
        event: 'contact-form_submission',
        attributes: {
            landingPage: landingPage,
            conversionPagePath: conversionPagePath,
            gtmCode: gtmCode,
            source: spotCode,
            campaignName: campaignName,
            campaignTerm: campaignTerm,
            campaignMedium: campaignMedium,
        }
    };
    Forms.initializeFormValidation(formSelector, validationRules, validationMessages, contactFormGAEvent);
}
window.addEventListener("load", () => {
    // Initializes form validation and submission for the Enquire Now form, if
    // one is present on the form. Successful submission results in a redirect to a thank you
    // page, since we validate server side the only failure mode is recapture failure.
    initializeFormValidation(formSelector, validationRules, validationMessages);
});
